var _defs, _ellipse, _path, _polygon, _path2, _polygon2, _path3, _polygon3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _ellipse2, _ellipse3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGybLogo2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.28 595.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-4{fill:none;stroke:#b91a1c;stroke-linecap:round;stroke-width:7px;}.cls-2{stroke-miterlimit:10;}.cls-3{fill:#b91a1c;}.cls-4{stroke-linejoin:round;}.cls-5{fill:#f9d5de;fill-rule:evenodd;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 282.17,
    cy: 294.38,
    rx: 206.7,
    ry: 207.85,
    transform: "translate(-101.45 432.62) rotate(-66.03)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.91,186.31c51.34-63,111.06-76.78,161-71.49,68,7.2,101.26,36,126.63,68.67"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "410.82 188.61 436.44 199.69 433.23 171.96 410.82 188.61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264.72,474.59C184,463,141.43,419,120.27,373.57c-28.81-61.84-21.14-105-6.09-143.44"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "125.61 239.32 122.02 211.63 99.83 228.58 125.61 239.32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M446.59,218.88c31.23,75.07,15,134-13.39,175.22-38.69,56.19-79.89,71.55-120.78,78.19"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "314.5 457.78 292.51 474.97 318.39 485.43 314.5 457.78"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M257.38,255.69v9.91c0,24.37-16.71,44.45-44.18,44.45-28.31,0-51-21.56-51-48.6,0-26.78,22.51-47.94,50.27-47.94,13.67,0,26,5.09,34.38,13.93,1,.93.69,1.87,0,2.81l-12,12.58a1.93,1.93,0,0,1-2.9.14,29.87,29.87,0,0,0-19.75-7.1,25.23,25.23,0,0,0-25.68,25.58c0,14.72,10.21,26.11,26.51,26.11,13.81,0,21-7.23,21.54-15.13H213.33a1.93,1.93,0,0,1-2.07-2V255.69a1.93,1.93,0,0,1,2.07-2h42A1.93,1.93,0,0,1,257.38,255.69Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M325.46,217l-28.17,48.47V306.3a1.93,1.93,0,0,1-2.07,2H275.75a1.93,1.93,0,0,1-2.07-2V265.2L245.51,217c-.83-1.61-.28-2.41,1.38-2.41h20.44a2.64,2.64,0,0,1,2.48,1.34l15.61,28,15.6-28a2.64,2.64,0,0,1,2.49-1.34h20.57C325.74,214.58,326.29,215.38,325.46,217Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M402.1,281.4c0,17.67-11.6,26.91-36.46,26.91H330.71a1.93,1.93,0,0,1-2.07-2V216.59a1.93,1.93,0,0,1,2.07-2h34.8c18.5,0,29,10.71,29,24.5,0,9.91-5.52,16.88-11.18,19.29C392.16,260.78,402.1,268.81,402.1,281.4Zm-38.8-46.73H352.25V250.2H363.3c5.38,0,9.39-2.14,9.39-8C372.69,236.41,368.54,234.67,363.3,234.67Zm15.32,43.65c0-7.1-5.79-9.38-12-9.38H352.25v19.29h14.36C373.65,288.23,378.62,285,378.62,278.32Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M343.41,289.76c3.29-52,9.68-64.06,15.49-63.65,5,.35,14,8.78,14.48,16.81.65,10.26-11.57,18-9.83,20.11,1.35,1.66,6.79-3.26,12.63-.88,6.58,2.69,11.9,13.94,10.38,20.42C384.38,291.87,367.16,295.5,343.41,289.76Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M223.52,359.62c0,10.58-9.51,15.55-18.08,15.55-7.63,0-14.54-4-17.71-8a1.19,1.19,0,0,1,0-1.51l5.54-6.27a1.09,1.09,0,0,1,1.66-.14c3.74,3,6.91,4.32,10.87,4.32,2.88,0,5.69-1.3,5.69-4.11,0-7-22.32-4.68-22.32-21.31,0-9.58,8.13-14.83,16.42-14.83,6.69,0,11.66,2.66,16,6.62a1.05,1.05,0,0,1,.14,1.51L216.46,338a1,1,0,0,1-1.51.28c-3.68-2.37-5.84-3.38-8.93-3.38-3.39,0-4.83,1.8-4.83,3.53C201.19,345.58,223.52,341.9,223.52,359.62Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M272.4,325v48.25a1,1,0,0,1-1.08,1.08H261.17a1,1,0,0,1-1.08-1.08V355.08H243.74v18.15a1,1,0,0,1-1.08,1.08H232.51a1,1,0,0,1-1.08-1.08V325a1,1,0,0,1,1.08-1.08h10.15a1,1,0,0,1,1.08,1.08v19.3h16.35V325a1,1,0,0,1,1.08-1.08h10.15A1,1,0,0,1,272.4,325Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M280.68,349.32a26,26,0,1,1,26,25.92A26,26,0,0,1,280.68,349.32Zm39.46,0c0-7.92-5.83-14-13.47-14s-13.46,6-13.46,14,5.83,13.83,13.46,13.83S320.14,357.17,320.14,349.32Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M376.87,340.82c0,10-6.76,16.92-19.08,16.92h-4.46v15.49a1,1,0,0,1-1.08,1.08H342.09a1,1,0,0,1-1.08-1.08V325a1,1,0,0,1,1.08-1.08h15.7C370.11,323.9,376.87,330.81,376.87,340.82Zm-11.73,0c0-4.89-4.11-6.12-7.56-6.12h-4.25v12.24h4.25C361,346.94,365.14,345.65,365.14,340.82Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 169.07,
    cy: 349.28,
    rx: 6.89,
    ry: 6.93,
    transform: "translate(-218.77 361.88) rotate(-66.03)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 395.26,
    cy: 349.28,
    rx: 6.93,
    ry: 6.89
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGybLogo2);
export default __webpack_public_path__ + "static/media/gyb_logo_2.78054c0ca456d5d7b4a0c348dea4a0e7.svg";
export { ForwardRef as ReactComponent };